module.exports = __webpack_public_path__ + "img/ИФ-1(А)-050-m.6cd66812.png";